module.exports = __webpack_public_path__ + "static/media/tree-step-2_1.6cb56f21.svg";